module.exports = __webpack_public_path__ + "img/appalachian-logo.69ea0f5f.jpg";